// extracted by mini-css-extract-plugin
export default {"root":"login_root__eAJ78","App":"login_App__WRGME","login":"login_login__1UhHk","login-wrapper":"login_login-wrapper__J+8-+"};